export const SENTRY = {
  DSN: 'https://f9fc2358269021ca267f1e7962ba6e6a@o4507888112435200.ingest.us.sentry.io/4507888114401280',
  SAMPLE_RATE: 0.6,
};
